import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { Heading } from '../../typography';
import { SelectCardCheckbox } from './SelectCardCheckbox';
import { ButtonStyles } from './styles';

export type SecondarySelectCardButtonProps = PropsWithChildren<SecondarySelectCardOption> & {
  onClick: (title: string) => void;
  selected?: boolean;
};

export type SecondarySelectCardOption = {
  value: string;
};

const Button = styled.div`
  ${ButtonStyles}
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${theme.spacings[3].rem};
`;

const Checkbox = styled(SelectCardCheckbox)`
  flex: 0 0 24px;
  height: 24px;
  margin-right: ${theme.spacings[2].rem};
`;

const Children = styled.div`
  display: flex;
`;

export const SecondarySelectCardButton: React.FC<SecondarySelectCardButtonProps> = ({
  children,
  onClick,
  selected = false,
  value,
  ...props
}) => (
  <Button onClick={() => onClick(value)} selected={selected} {...props}>
    <Content>
      <Checkbox checked={selected} />
      <Heading size={6}>{value}</Heading>
    </Content>
    <Children>{children}</Children>
  </Button>
);
